var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconWithTooltip",on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.showToolTip)?_c('ToolTip',{attrs:{"variant":"down","text":_vm.text}}):_vm._e(),_c('img',{staticClass:"iconWithTooltip__img",style:(_vm.styles),attrs:{"src":_vm.img,"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }